import { Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from "ag-grid-angular";
import { EspGridLoadingParams } from "../grid-loading/grid-loading.component";

/** Loading spinner for panels and grids (`<esp-grid-loading>`). */
@Component({
  standalone: false,
  selector: 'wfm-esp-loading-rows-overlay',
  templateUrl: './loading-rows-overlay.component.html'
})
export class LoadingRowsOverlayComponent implements ILoadingOverlayAngularComp {
  params?: EspGridLoadingParams;

  agInit(params: EspGridLoadingParams): void {
    this.params = params;
  }
}
